import { watch, onMounted, Ref } from '@vue/composition-api';

export async function useSendComment(comment: any, params: any, callback: Function) {
    callback && callback();
    const { photoId, photoAuthorId, isReplyInput, userInfo, replyToCommentId, expTag } = params;
    await comment.addComment(
        {
            photoId,
            photoAuthorId,
            content: isReplyInput ? comment.sendReplyContent.trim() : comment.sendContent.trim(),
            replyToCommentId,
            expTag,
        },
        userInfo,
        isReplyInput,
    );
}

export function useSubCommentList(subCommentCurrentPage: { value: number }, subCommentsList: Ref<never[]>, comment: any) {
    onMounted(() => {
        watch(subCommentCurrentPage, () => {
            if (subCommentCurrentPage.value === 0) {
                subCommentsList.value = [];
                return;
            }
            // 第一页读10个
            if (subCommentCurrentPage.value === 1) {
                subCommentsList.value = comment.subComments.slice(0, 10);
                return;
            }
            // 后面每页读20个
            subCommentsList.value = comment.subComments.slice(0, 10 + subCommentCurrentPage.value * 20);
        });
    });
}

export function useJumpToProfile(authorId: string) {
    const targetUrl = `/profile/${authorId}`;
    window.open(targetUrl, '_blank');
}